import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=48682a60&scoped=true&"
import script from "./ArticleEditor.vue?vue&type=script&lang=ts&"
export * from "./ArticleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleEditor.vue?vue&type=style&index=0&id=48682a60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48682a60",
  null
  
)

export default component.exports